import { appStoreLenses } from 'root/src/client/logic/app/lenses'
import path from 'ramda/src/path'

const { viewBrandName } = appStoreLenses

export default state => viewBrandName(state) || path(['app', 'userData', 'creatorData', 'displayName'], state) || ''
